import { getCasinoDirectIntegrationUrl } from '../../adapters/casino'
import { GamesLanguages } from '../constants'

export const setDirectIntegrationURL = async ({
  casinoProvider,
  desktopSlug,
  mobileSlug,
  depositUrl,
  lobbyUrl,
  isMobile,
  isLoggedIn,
  locale,
}) => {
  const isDemo = !isLoggedIn
  const language = GamesLanguages?.direct_integration?.[locale]
  const demoCurrency = locale === 'pt' ? 'BRL' : 'USD'

  const body = {
    provider: casinoProvider,
    gameCode: isMobile ? mobileSlug : desktopSlug,
    channel: isMobile ? 'MOBILE' : 'WEB',
    lang: language,
    lobbyUrl: lobbyUrl,
    depositUrl: depositUrl,
    currency: demoCurrency,
  }

  const { ok, data } = await getCasinoDirectIntegrationUrl(isDemo, body)
  if (ok) return data?.data?.url
  return null
}
